import React from 'react';
import PropTypes from 'prop-types';

import { Location } from '../Elements';

import classes from './FilterItemLocation.module.scss';

const FilterItemLocation = ({ item }) => {
  return (
    <div className={classes.multiItem}>
      <Location country={item} size={24} />
    </div>
  );
};

FilterItemLocation.propTypes = {
  item: PropTypes.string
};

export default FilterItemLocation;
